import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseComponent } from '../../../../../../models/base/base-component';
import { CompactMenu } from '../../../../../../models/menu/dto/compact-menu';

@Component({
  selector: 'app-display-menu-section-body',
  templateUrl: './display-menu-section-body.component.html',
  styleUrls: ['./display-menu-section-body.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class DisplayMenuSectionBodyComponent extends BaseComponent {
  constructor() {
    super();
  }

  @Input() menu: CompactMenu;
  @Input() productOverflowTitle: string;
  @Input() mergeKey: string;
  @Input() bindTo: any;
  @Input() loopDuration: number;
  @Input() nMenus: number;
  @Input() index: number;
  @Input() formPristine: boolean = true;
  @Input() menuIsPartOfCollection = false;
  @Output() openInformationModal = new EventEmitter();
}
